import axios from 'axios';
import { ACCESS_TOKEN_KEY } from '../auth/AuthContext';

const baseURL =
  process.env.REACT_APP_DICTIONARY_API_URL || 'https://koshaapidev.vag.org.np';

export const dictionaryApi = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

dictionaryApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    config.headers.delete('Content-Type');
  }
  return config;
});
